<template>
  <sf-modal
    v-if="modalOpen"
    size="xs"
    :scrollable-content="true"
    @close="close"
  >
    <template #title>
      <span v-dompurify-html="modalTitle" />
    </template>

    <template #body>
      <move-list
        :title="title"
        :query-params="queryParams"
        :post-params="postParams"
        :permanent-entries="permanentEntries"
        :permanent-category="permanentCategory"
        @navigate="navigateTo"
        @move="moveTo"
      />
    </template>

    <template #footer>
      <button class="sf-btn" @click="close">
        {{ I18n.t('confirmation.cancel') }}
      </button>
    </template>
  </sf-modal>
</template>

<script>
import { SfModal } from '@app/shared/vue/components/sf-modal'
import MoveList from './move-list'

import api from '../api/index'

export default {
  components: {
    SfModal,
    MoveList,
  },
  data() {
    return {
      modalOpen: false,
      batchMove: false,
      title: '',
      id: null,
      type: null,
      selectedEntryIds: [],
      permanentCategory: null,
      permanentEntries: [],
    }
  },
  computed: {
    modalTitle() {
      return this.batchMove
        ? I18n.t('permanent.move_list.batch_move_title')
        : I18n.t('permanent.move_list.move', { title: this.title })
    },
    moveUrl() {
      if (this.batchMove) {
        return Silverfin.Routes.batch_move_permanent_entries_path({
          firm_id: Silverfin.currentFirmId,
          company_id: Silverfin.currentCompanyId,
          _options: true,
        })
      } else {
        return Silverfin.Routes.move_permanent_entries_path({
          firm_id: Silverfin.currentFirmId,
          company_id: Silverfin.currentCompanyId,
          _options: true,
        })
      }
    },
    queryParams() {
      return this.batchMove
        ? { selected_entries: this.selectedEntryIds.join(',') }
        : { type: this.type, id: this.id }
    },
    postParams() {
      return this.batchMove
        ? { selected_entries: this.selectedEntryIds }
        : { type: this.type, id: this.id }
    },
  },
  methods: {
    close() {
      this.modalOpen = false
    },
    setData(params) {
      this.batchMove = params.batchMove
      this.title = params.title
      this.id = params.id
      this.type = params.type
      this.selectedEntryIds = params.selectedEntryIds
      this.permanentCategory = params.permanentCategory
      this.permanentEntries = params.permanentEntries
    },
    openModal(params) {
      this.setData(params)
      this.modalOpen = true
    },
    navigateTo(params) {
      api
        .navigateTo(this.navigateUrl(params))
        .then((response) => this.setData(response))
    },
    moveTo(payload) {
      api.moveTo(this.moveUrl, payload)
    },
    navigateUrl(params) {
      if (this.batchMove) {
        return Silverfin.Routes.batch_move_modal_permanent_entries_path({
          firm_id: Silverfin.currentFirmId,
          company_id: Silverfin.currentCompanyId,
          ...params,
          _options: true,
        })
      } else {
        return Silverfin.Routes.move_modal_permanent_entries_path({
          firm_id: Silverfin.currentFirmId,
          company_id: Silverfin.currentCompanyId,
          ...params,
          _options: true,
        })
      }
    },
  },
}
</script>
